<template>
  <div class="columns" v-if="comment">
    <div class="column is-narrow tw-pr-0">
      <div
        @click="didLike ? unlike() : like()"
        class="tw-flex tw-flex-col tw-items-center"
      >
        <b-icon
          class="tw-cursor-pointer"
          @click="like"
          icon="thumb-up"
          :type="didLike ? 'is-primary' : 'is-light'"
          size="is-small"
        />
        <span
          class="tw-text-base"
          :class="didLike ? 'tw-text-primary' : 'tw-text-grey-lighter'"
        >
          {{ comment.like_count }}
        </span>
      </div>
    </div>
    <div class="column">
      <div class="media" v-if="comment.user">
        <div class="media-left">
          <figure class="image is-32x32">
            <img
              class="is-elongated"
              v-lazy="comment.user.avatar_thumb_url + '?ts=' + auth.timestamp"
              alt="User image"
            />
          </figure>
        </div>
        <div class="media-content">
          <p class="title is-6">Posted by {{ comment.user.full_name }}</p>
          <p class="subtitle is-6 tw-text-grey-lighter">
            <small>{{ comment.createdAtFromNow }}</small>
          </p>
        </div>
      </div>
      <p class="tw-mt-4">
        {{ comment.comment }}
      </p>
    </div>
    <div class="media-right">
      <b-dropdown position="is-top-left" aria-role="list">
        <button slot="trigger" class="button is-white tw-min-w-0">
          <b-icon icon="dots-vertical"></b-icon>
        </button>

        <b-dropdown-item
          v-if="comment.user.id !== user.id"
          @click="reportComment"
          aria-role="listitem"
        >
          Report comment
        </b-dropdown-item>
        <b-dropdown-item v-else @click="deleteComment" aria-role="listitem">
          Delete comment
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Comment from '@/models/Comment'
import Like from '@/models/CommentLike'

export default {
  props: {
    value: {
      type: Comment
    }
  },
  data() {
    return {
      loading: false,
      comment: null
    }
  },
  mounted() {
    this.comment = this.value
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      user: state => state.auth.user
    }),
    didLike() {
      return !!this.comment.liked
    }
  },
  methods: {
    incrementLike() {
      this.comment.liked = this.user
      this.comment.like_count = this.comment.like_count + 1
    },

    decrementLike() {
      this.comment.liked = null
      this.comment.like_count = this.comment.like_count - 1
    },

    like() {
      if (!this.loading) {
        this.loading = true
        const liked = new Like({}).for(this.comment)
        this.incrementLike()
        liked
          .save()
          .then(response => {
            const comment = new Comment(response.data)
            this.comment = comment
            this.$emit('liked', comment)
          })
          .catch(() => {
            this.decrementLike()
          })
          .then(() => {
            this.loading = false
          })
      }
    },

    unlike() {
      if (!this.loading) {
        this.loading = true
        const liked = new Like(this.comment.liked).for(this.comment)
        this.decrementLike()
        liked
          .delete()
          .then(response => {
            const comment = new Comment(response.data.data)
            this.comment = comment
            this.$emit('unliked', comment)
          })
          .catch(() => {
            this.incrementLike()
          })
          .then(() => {
            this.loading = false
          })
      }
    },

    reportComment() {
      this.$emit('report', this.comment)
    },

    deleteComment() {
      this.$emit('delete', this.comment)
    }
  },
  watch: {
    value(val) {
      this.comment = val
    },
    comment(val) {
      this.$emit('input', val)
    }
  }
}
</script>
